import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { CallbackService } from '@callback/data-access';
import { CallbackFormComponent } from '../phone-modal/callback-form.component';

@Component({
  selector: 'sd-smart-house-modal',
  templateUrl: './smarthome-request-modal.component.html',
  styleUrls: ['./smarthome-request-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CallbackFormComponent],
})
export class SmarthomeRequestModalComponent implements OnDestroy {
  constructor(private callbackService: CallbackService) {}

  ngOnDestroy(): void {
    this.callbackService.resetProcess();
  }
}
